import React from 'react'

import { BrandAssetBoxProps } from './types'
import { BrandAssetBoxStyled, BrandAssetBoxMediaStyled, BrandAssetBoxTitleStyled, BrandAssetBoxCtaStyled } from './styles'
import StaticImage from './../../atoms/ImageStatic'
import Button from './../../atoms/Button'

const BrandAssetBox: React.FC<BrandAssetBoxProps> = ({ data: { title, cta, image } }) => {
  return (
    <BrandAssetBoxStyled>
      {image && (
        <BrandAssetBoxMediaStyled href={cta.url} download={cta.urlIsDownload}>
          <StaticImage image={image} />
        </BrandAssetBoxMediaStyled>
      )}
      <BrandAssetBoxTitleStyled>{title}</BrandAssetBoxTitleStyled>
      {cta && cta.urlText && (
        <BrandAssetBoxCtaStyled>
          <Button variant="isLarge" {...cta} />
        </BrandAssetBoxCtaStyled>
      )}
    </BrandAssetBoxStyled>
  )
}

export default BrandAssetBox
